import axios from "axios";

/**
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ node requests ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

export function get(url, params = {}) {
  return axios({ method: "get", url: url, params }).then((res) => {
    if (res.data) {
      return res.data;
    } else {
      throw new Error(`null response ${url} ${JSON.stringify(params)}`);
    }
  });
}

export function rpc(url, method, params) {
  const data = {
    jsonrpc: "2.0",
    id: 1,
    method,
    params,
  };
  return axios({ method: "post", url, data }).then((res) => {
    if (res.data) {
      return res.data.result;
    } else {
      throw new Error(`null response ${url} ${JSON.stringify(params)}`);
    }
  });
}
